var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{attrs:{"color":_vm.color,"toggled":_vm.toggled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._v(_vm._s(_vm.currentLabel))])}
var staticRenderFns = []

export { render, staticRenderFns }